import React from "react";
import { LocalizationProvider } from "@material-ui/pickers";
import DayjsAdapter from "@material-ui/pickers/adapter/dayjs";
// import MomentUtils from "@date-io/moment";
import dayjs from "dayjs";
import { language2DayjsMap } from "./langs";
import { useTranslation } from "./langs/useTranslation";

import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";

import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/ja";
import "dayjs/locale/ko";
import "dayjs/locale/ru";

dayjs.extend(utc);
dayjs.extend(duration);

const Provider = ({ children }) => {
  const { userLanguage } = useTranslation();

  return (
    <LocalizationProvider
      dateLibInstance={dayjs}
      dateAdapter={DayjsAdapter}
      locale={language2DayjsMap[userLanguage]}
    >
      {children}
    </LocalizationProvider>
  );
};

export default Provider;
